import { ConflictError } from "./conflict-error";

// Thrown when a picking round is signed off while the order still owes empty load carriers
// ("Leergut") and no other round of that order could still supply them. The ordered quantity is a
// floor on what the round picks — a site that asked for eighteen boxes gets at least eighteen —
// so a round finishing short would close an order whose empties never left the yard.
//
// 409, not 400: the payload is well formed, it is the stock that has moved out from under it. The
// per-carrier detail belongs on the carrier page, which shows each ordered floor beside what the
// picker entered and can name the carrier before the request is ever sent.
export class OrderedLoadCarriersNotPickedError extends ConflictError {
	constructor() {
		super("stock.ordered_load_carriers_not_picked");
		this.name = "OrderedLoadCarriersNotPickedError";
	}
}
